import React, { useState } from "react";
import {
  Button,
  Divider,
  Grid,
  Box,
  useNavigate,
  useCreateGroupMutation,
  useGetAllScreensMutation,
  toast,
  useEffect,
  useGetscreensforgroupMutation,
   GetCookie,
   LoadingSpinner,
} from "../../../Libraries/Screens/index";
import Groupoptions from '../../../components/Groups/Groupoptions';
import ModalComp from "../../../components/Modal";
import Screenimage from "../../../Assets/svgs/groupscreenimg.svg";
import Groupmodalimg from "../../../Assets/Images/groupmodalimg.png";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import AppbarTop from "../../../components/PortalSidebar/Appbar/AppbarTop";
import ViewgroupScreens from "../../../components/Groups/ViewgroupScreens";
import add_media_image from "../../../Assets/svgs/add_media_image.svg"
import { Link } from "react-router-dom";

import {
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  InputLabel,
  FormControl,
} from "@mui/material";
import { BASEURL } from "../../../Utils/Constants/constants";

export default function AddNewGroup() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showScreens, setShowScreens] = useState(false);
  const [dismapbtn, setdismapbtn] = useState("false");
  const [modalStep, setModalStep] = useState("groupName");
  const [groupName, setGroupName] = useState("");
  const [selectedScreens, setSelectedScreens] = useState([]);
  const [allgroupdata, setallgroupdata] = useState([]);
  const [groupscreendata, setgroupscreeensdata] = useState([]);
  const [creategroupdata , setcreategroupdata] = useState([]);
  const [singlegroupdata , setsinglegroupdata] = useState([]);
  const [errormessage, seterrormessage] = useState('');
  const [groupid, setgroupid] = useState();
  const [screenOptions, setallscreensdata] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const [creategroup, { isLoading }] = useCreateGroupMutation();
  const [getAllScreensfromdb] = useGetAllScreensMutation();
  const [getgroupscreens] = useGetscreensforgroupMutation();
  const [error, setError] = useState("");
  const [nodata, setnodata] = useState(false);
  const [screenCounts, setScreenCounts] = useState({});

////////////////////////////////
// Open Model OnClick Function
///////////////////////////////
  const openAddGroupModal = () => {
    setModalStep("groupName");
    setGroupName("");
    setSelectedScreens([]);
    setIsModalOpen(true);
  };
////////////////////////////////
// Close Model OnClick Function
///////////////////////////////
  const closeModal = () => {
    setIsModalOpen(false);
    setModalStep("groupName");
    setGroupName("");
    setSelectedScreens([]);
  };
  /////////////////////////////
  // Get All the Screens Data 
  ////////////////////////////
  const getAllScreens = async () => {
    const customerid = localStorage.getItem("txt_customer_id");
      const verifyscreenotp = new FormData();
      verifyscreenotp.append("txt_customer_id",customerid);
      verifyscreenotp.append("security_token", await GetCookie("es_token"));
      verifyscreenotp.append("ser_collection_id", 0);
  
      try {
        const response = await getgroupscreens(verifyscreenotp);
        if(response.data.status === 'true'){
          const screensdata = response.data.data;
          setallscreensdata(screensdata);
          seterrormessage('');
        }else{
          setallscreensdata([]);
          seterrormessage(response.data.message);
        }
      } catch (error) {
        toast.error(error.status);
        console.log(error);
      }
    };
    /////////////////////////
    // Create Group Function
    /////////////////////////
    const handleAddGroupName = async () => {

      if (!groupName.trim()) return; 
      const customerid = localStorage.getItem("txt_customer_id");
      const creategroupdata = new FormData();
      creategroupdata.append("function", "CREATE_GROUP");
      creategroupdata.append("txt_customer_id", customerid);
      creategroupdata.append("txt_collection_name", groupName);
      creategroupdata.append("security_token", await GetCookie("es_token"));
        try {
          const response = await creategroup(creategroupdata);
          if(response.data.status === "true"){
              toast.success(response.data.message);
              setgroupid(response.data.data.ser_collection_id);
              getAllGroups();
              getAllScreens(); 
              setModalStep("selectScreens"); 

        }else{
            toast.error(response.data.message);
          }
          
    } catch (error) {
      console.error("Error creating group:", error);
    }
      
    };
    ///////////////////////////
    // Assign Screens to Group
    ///////////////////////////
    const handleAddScreens = async (screens) => {
      if (!screens || screens.length === 0) return;
      console.log("Testing4");
      screens = screens.filter(item => item !== undefined);
      const datascreens = screenOptions.filter(
          option => screens.includes(option.ser_screen_id)
      );
      const screenIds =  datascreens.map(item => item.ser_screen_id);;
      
      const customerid = localStorage.getItem("txt_customer_id");
      const creategroupdata = new FormData();
      creategroupdata.append("function", "ASSIGN_GROUP");
      creategroupdata.append("ser_collection_id", groupid);
      creategroupdata.append("txt_customer_id", customerid);
      creategroupdata.append("security_token", await GetCookie("es_token"));
      creategroupdata.append("screen_ids", JSON.stringify(screenIds));

      try {
        const response = await creategroup(creategroupdata);
        if (response.data.status === "true") {
          toast.success(response.data.message);
          closeModal();
          getAllGroups();
          setShowScreens(false);
          setdismapbtn(true);
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        console.error("Error assigning screens:", error);
      }
    };

    /////////////////////////////////////
    // Map Screen OnCLick Functionality
    ///////////////////////////////////
    const handleMapScreens = async (group) => {
       setgroupid(group.ser_collection_id);
        const sgroupdata = [
          {
            value: group.ser_collection_id,
            label: group.txt_collection_name,
            footer_value: group.footer_value,
            footer_option: group.footer_option,
          },
      ];
      setsinglegroupdata(sgroupdata);
      getAllScreens(); 
      setShowScreens(true);
      setdismapbtn(true);
    };
    ////////////////////////////////
    //Edit Media to Group Function
    ///////////////////////////////
    const handleeditmedia =  async (group) =>{
      navigate("/groupposts", {
        state: [
          {
            value: group.ser_collection_id,
            label: group.txt_collection_name,
            footer_value: group.footer_value,
            footer_option: group.footer_option,
          },
        ],
      });
    }
    /////////////////////
    //Get All Group Data
    /////////////////////
    const getAllGroups = async () => {
      const customerid = localStorage.getItem("txt_customer_id");
      const creategroupdata = new FormData();
      creategroupdata.append("function", "GET_ALL_GROUPS");
      creategroupdata.append("txt_customer_id", customerid);
      creategroupdata.append("security_token", await GetCookie("es_token"));

      try {
        const response = await creategroup(creategroupdata);
        if (response.data.connection === "true") {
          if (response.data.status === "true") {
            const groupdata = response.data.data;
            setallgroupdata(groupdata);
            groupdata.forEach((group) => getscreensforgroup(group));
          } else {
            setnodata(true);
            setallgroupdata("");
          }
        }
      } catch (error) {
        console.error("Error fetching groups:", error);
      }
    };
    /////////////////////////
    //Render Change Function
    /////////////////////////
    useEffect(() => {
      getAllGroups();
    }, []);
  

  const allowedPattern = /^[a-zA-Z0-9 .,()_\-]+$/;

  const handleGroupNameChange = (e) => {
    let inputText = e.target.value;
    if (inputText && !allowedPattern.test(inputText)) {
      toast.error("Invalid characters entered.");
      inputText = inputText.replace(/[^a-zA-Z0-9 .,()_\-]/g, "");
    }
    const textinput = inputText.trim().length;
    setGroupName(inputText);
    if (textinput > 50) {
      setError("Not more than 50 characters allowed.");
    } else {
      setError("");
    }
  };


  const handleScreensChange = (event) => {
     const {
      target: { value },
    } = event;
    setSelectedScreens(typeof value === "string" ? value.split(",") : value);
    const selected = (typeof value === "string" ? value.split(",") : value).filter(Boolean);
    setdismapbtn(selected.length === 0);

  }
  const renderModalContent = () => {
    if (modalStep === "groupName") {
      return (
        <div className="d-flex flex-column justify-content-center align-items-center py-4">
          <div
            className="d-flex flex-column justify-content-center align-items-center gap-3 w-75"
            style={{ fontFamily: "Roboto, sans-serif" }}
          >
            <img src={Groupmodalimg} width={151} height={151} alt="Group" />
            <h3 className="fs-24 fw-semibold">Add a Group</h3>
            <p
              className="text-center fs-16"
              style={{ color: "#00000099" }}
            >
              Enter a name for your new group. You can add screens to this
              group after creation.
            </p>
            {error && (
              <div style={{ color: "red", marginTop: "4px", fontSize: "14px" }}>
                {error}
              </div>
              )}
            <input
              style={{ border: "1px solid #333333" }}
              className="flex form-control border-1"
              type="text"
              placeholder="Group name"
              value={groupName}
              onChange={handleGroupNameChange}
            />
            <Button
              variant="contained"
              sx={{ width: "100%", mt: 2 }}
              onClick={handleAddGroupName}
              disabled={!groupName.trim()}
              className="capitalized fs-14 fw-bold"
            >
              Add
            </Button>
          </div>
        </div>
      );
    } else if (modalStep === "selectScreens") {
      return (
        <div className="d-flex flex-column justify-content-center align-items-center py-4">
          <div
            className="d-flex flex-column justify-content-center align-items-center gap-2 w-75"
            style={{ fontFamily: "Roboto, sans-serif" }}
          >
            <img src={Groupmodalimg} width={151} height={151} alt="Group" />
            <h3 className="fs-24 fw-semibold">
              Add Screen to {groupName}
            </h3>
            <p
              className="text-center fs-16"
              style={{ color: "#00000099" }}
            >
              Select screen(s) to add to this group.
            </p>
            {errormessage &&(
              <span className="statuserror">{errormessage}</span>
            )}
            <FormControl sx={{ m: 1, width: "100%" }}>
              <InputLabel id="select-screens-label">
                Select the Screen
              </InputLabel>
              <Select
                labelId="select-screens-label"
                multiple
                value={selectedScreens}
                onChange={handleScreensChange}
                renderValue={(selected) =>
                  selected
                    .map(
                      (id) =>
                        screenOptions.find((opt) => opt.ser_screen_id === id)?.txt_screen_name
                    )
                    .join(", ")
                }
                label="Select the Screen"
              >
                {screenOptions && screenOptions.map((option) => (
                  <MenuItem key={option.ser_screen_id} value={option.ser_screen_id}>
                    <Checkbox checked={selectedScreens.includes(option.ser_screen_id)} />
                    <ListItemText primary={option.txt_screen_name} />
                  </MenuItem>
                ))}
              </Select>

            </FormControl>
            <Button
              variant="contained"
              sx={{ width: "100%", mt: 2 }}
              onClick={() => handleAddScreens(selectedScreens)}
              disabled={dismapbtn}
              className="capitalized fs-14 fw-bold"
            >
              Map
            </Button>
          </div>
        </div>
      );
    }
  };
  const filteredGroups = (allgroupdata && allgroupdata.filter((group) =>
    group.txt_collection_name?.toLowerCase().includes(searchTerm.toLowerCase())
  ));

 const getscreensforgroup = async (group) => {
  const formObj = new FormData();
  formObj.append("txt_customer_id", localStorage.getItem("txt_customer_id"));
  formObj.append("security_token", await GetCookie("es_token"));
  formObj.append("ser_collection_id", group.ser_collection_id);

  try {
    const returned = await getgroupscreens(formObj).unwrap();

    if (returned.status === "true" && Array.isArray(returned.data)) {
      const assignedScreens = returned.data.filter(
        (screen) =>
          screen.ser_collection_id &&
          screen.ser_collection_id === group.ser_collection_id
      );

      const assignedCount = assignedScreens.length;

      setScreenCounts((prev) => ({
        ...prev,
        [group.ser_collection_id]: assignedCount,
      }));
    } else {
      console.warn("No valid data received for group", group.ser_collection_id);
      setScreenCounts((prev) => ({
        ...prev,
        [group.ser_collection_id]: 0,
      }));
    }
  } catch (error) {
    console.error("Error fetching screens:", error);
    setScreenCounts((prev) => ({
      ...prev,
      [group.ser_collection_id]: 0,
    }));
  }
};


  return (
    <>
     {isLoading ? <LoadingSpinner /> : null}
      {/* <AppbarTop /> */}
      <Box className="mainboxscreen py-5 " 
        sx={{
              width:'98%'
        }}
      >
        <Box sx={{ flexGrow: 1 }} 
        className="pr-1 pl-2 pb-4"
        style={{
                    backgroundColor: "#FFFFFF",
                    color: "#000",
                    boxShadow: "rgba(149, 157, 165, 0.1) 0px 8px 8px",
                    borderRadius: "10px",
                }}
        >
          <ModalComp
            open={isModalOpen}
            onCloseModal={closeModal}
            modalwidth={"40%"}
            modalheight={"540px"}
            closeicon ={true}
          >
            {renderModalContent()}
          </ModalComp>

          <div className="d-flex justify-content-between pt-1  px-3 pt-4">
              <span className="font-bold text-xl" style={{ fontSize: "20px" }}>
                    Group
                </span>
                <div className="d-flex justify-content-between">

                  <div id="searchboxmain" className="flex align-items-center form-control border-0 shadow-sm text-center py-2 mt-2 ">
                    <SearchIcon />
                    <input
                      className="form-control border-0 searchbox"
                      type="text"
                      id="searchbox"
                      placeholder="Search group"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      onFocus={(e) => e.target.classList.add("no-border")}
                    />
                  </div>
                  <div className="px-1 py-2">
                    <Button
                      style={{ backgroundColor: "#1776EE" }}
                      className="text-capitalize text-white px-3 "
                      sx={{ width: "100%" }}
                      onClick={openAddGroupModal}
                    >
                      <AddIcon className="fs-12" />
                      Add group
                    </Button>
                  </div>
                </div>
            </div>

          <Grid container className="pt-3 mainclass">
            {filteredGroups && filteredGroups.length > 0 ? (
              filteredGroups.map((group, index) => (
                <Grid key={index} item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <div
                    className="surface-0 px-3 py-2 m-2 screencard"
                    style={{ borderRadius: "8px" }}
                  >
                    <div className="flex justify-content-between align-items-center mb-0">
                      <span
                        className="font-bold text-capitalize text-limit fs-14"
                        style={{ color: "#1A75E8" }}
                      >
                        {group.txt_collection_name}
                      </span>
                      <Groupoptions groupdata={group} onGroupUpdate={getAllGroups} />
                    </div>
                    {/* <Divider sx={{ my: 0.5, mb: 2 }} /> */}
                    <hr className="mx-0 my-0 pb-2" style={{ borderColor: "#a2a2a2" }} />
                    <div className="flex align-items-center justify-content-left py-2">
                      <img
                        src={Screenimage}
                        width="50%"
                        alt="lcd"
                      />
                    </div>
                    <div className="orientationdiv pb-2">
                      <span className="screenspan">Screens</span>
                      <span
                        className=""
                        style={{
                          color: "#1776EE",
                          cursor: "default",
                          textDecoration: "none !important",
                          fontSize: "12px",
                        }}
                      >
                        {screenCounts[group.ser_collection_id] > 0
                          ? `${screenCounts[group.ser_collection_id]} Screen${screenCounts[group.ser_collection_id] > 1 ? "s" : ""}`
                          : "No Screen"}
                      </span>
                    </div>
                    {/* <Divider /> */}
                    <hr className="mx-0 my-0" style={{ borderColor: "#a2a2a2" }} />
                    <Box sx={{ flexGrow: 1, marginTop: "5%" }}>
                      <Grid container spacing={1}>
                        <Grid item xs={12} md={6} lg={6} xl={6}>
                          <Button
                            variant="outlined"
                            sx={{ width: "100%" }}
                            onClick={() => handleMapScreens(group)}
                            className="capitalized fs-12 fw-bold"
                          >
                            Map Screen
                          </Button>
                        </Grid>
                        <Grid item xs={12} md={6} lg={6} xl={6}>
                          <Button
                            variant="contained"
                            sx={{ width: "100%" }}
                            onClick={() => handleeditmedia(group)}
                            className="capitalized fs-12 fw-bold"
                          >
                            Edit Media
                          </Button>
                        </Grid>
                      </Grid>
                    </Box>
                  </div>
                </Grid>
              ))
            ) : (
              nodata && (
                <div className="col d-flex justify-content-center">
                  <img
                    style={{ maxWidth: "600px", minWidth: "200px", width: "100%" }}
                    src={add_media_image}
                    alt="No media"
                  />
                </div>
              )
            )}
          </Grid>
        </Box>
      </Box>
    <ViewgroupScreens
      open={showScreens}
      onClose={() => setShowScreens(false)}
      data={screenOptions}
      groupdata={singlegroupdata}
      getgroupscreens={getgroupscreens}
      mapscreenfunction = {handleAddScreens}
      GetCookie= {GetCookie}
      displaymapbutton = {true}
      disabledbtn = {dismapbtn}
      LoadingSpinner = {LoadingSpinner}
    />
    </>
  );
}
